import { __ } from '@wordpress/i18n'

export default { notFound: __('No testimonials', 'dhsv_theme') }
